/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateVectorStoreFileBatchRequest = {
  vectorStoreId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createVectorStoreFileBatchRequest:
    components.CreateVectorStoreFileBatchRequest;
};

/** @internal */
export const CreateVectorStoreFileBatchRequest$inboundSchema: z.ZodType<
  CreateVectorStoreFileBatchRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  vector_store_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  CreateVectorStoreFileBatchRequest:
    components.CreateVectorStoreFileBatchRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "vector_store_id": "vectorStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateVectorStoreFileBatchRequest": "createVectorStoreFileBatchRequest",
  });
});
/** @internal */
export type CreateVectorStoreFileBatchRequest$Outbound = {
  vector_store_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  CreateVectorStoreFileBatchRequest:
    components.CreateVectorStoreFileBatchRequest$Outbound;
};

/** @internal */
export const CreateVectorStoreFileBatchRequest$outboundSchema: z.ZodType<
  CreateVectorStoreFileBatchRequest$Outbound,
  z.ZodTypeDef,
  CreateVectorStoreFileBatchRequest
> = z.object({
  vectorStoreId: z.string(),
  xOnBehalfOf: z.string().optional(),
  createVectorStoreFileBatchRequest:
    components.CreateVectorStoreFileBatchRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    vectorStoreId: "vector_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    createVectorStoreFileBatchRequest: "CreateVectorStoreFileBatchRequest",
  });
});

export function createVectorStoreFileBatchRequestToJSON(
  createVectorStoreFileBatchRequest: CreateVectorStoreFileBatchRequest,
): string {
  return JSON.stringify(
    CreateVectorStoreFileBatchRequest$outboundSchema.parse(
      createVectorStoreFileBatchRequest,
    ),
  );
}
export function createVectorStoreFileBatchRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateVectorStoreFileBatchRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateVectorStoreFileBatchRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateVectorStoreFileBatchRequest' from JSON`,
  );
}
